import { useEffect, useState } from 'react';
import { selectionProcessesPublic } from '@/services/selectionProcesses';

export default function RegionalInstitutionPicker({ slug, regionalId, institutionId, onChange, disabled = false }) {
  const [regionals, setRegionals] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [loadingInst, setLoadingInst] = useState(false);

  useEffect(() => {
    selectionProcessesPublic
      .listRegionals(slug)
      .then(res => setRegionals(res.data || []))
      .catch(() => setRegionals([]));
  }, [slug]);

  useEffect(() => {
    if (!regionalId) {
      setInstitutions([]);
      return;
    }
    setLoadingInst(true);
    selectionProcessesPublic
      .listInstitutions(regionalId)
      .then(res => setInstitutions(res.data || []))
      .finally(() => setLoadingInst(false));
  }, [regionalId]);

  const selectCx = isDisabled =>
    [
      'mt-1.5 block w-full rounded-lg border bg-white px-3.5 py-2.5 text-base text-slate-900 shadow-sm ring-1 ring-inset ring-slate-200 transition',
      'placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset border-slate-200',
      isDisabled ? 'cursor-not-allowed opacity-50' : ''
    ].join(' ');

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <label className="block">
        <span className="block text-sm font-medium text-slate-700">
          Regional{' '}
          <span
            className="text-red-500"
            aria-hidden="true"
          >
            *
          </span>
        </span>
        <select
          value={regionalId || ''}
          disabled={disabled || regionals.length === 0}
          onChange={e => onChange({ regional_id: Number(e.target.value) || '', institution_id: '' })}
          className={selectCx(disabled || regionals.length === 0)}
        >
          {regionals.length === 0 ? (
            <option value="">Nenhuma regional disponível</option>
          ) : (
            <>
              <option value="">Selecione...</option>
              {regionals.map(r => (
                <option
                  key={r.id}
                  value={r.id}
                >
                  {r.name}
                </option>
              ))}
            </>
          )}
        </select>
      </label>
      <label className="block">
        <span className="block text-sm font-medium text-slate-700">
          Unidade de Ensino{' '}
          <span
            className="text-red-500"
            aria-hidden="true"
          >
            *
          </span>
        </span>
        <select
          value={institutionId || ''}
          disabled={disabled || !regionalId || loadingInst}
          onChange={e => onChange({ institution_id: Number(e.target.value) || '' })}
          className={selectCx(disabled || !regionalId || loadingInst)}
        >
          <option value="">{loadingInst ? 'Carregando...' : 'Selecione...'}</option>
          {institutions.map(i => (
            <option
              key={i.id}
              value={i.id}
            >
              {i.name} — {i.city}/{i.state}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
